import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../helpers'
import {Item1} from '../../content/janara/Item1'
import {Item2} from '../../content/janara/Item2'
import {Item3} from '../../content/janara/Item3'
import {Item4} from '../../content/janara/Item4'
import {Item5} from '../../content/janara/Item5'
import {Item6} from '../../content/janara/Item6'
import {Item7} from '../../content/janara/Item7'
import {Item8} from '../../content/janara/Item8'

const AdjuntoJanara: FC = () => (
  <div
    id='kt_activities7'
    className='bg-body'
    data-kt-drawer='true'
    data-kt-drawer-name='activities7'
    data-kt-drawer-activate='true'
    data-kt-drawer-overlay='true'
    data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
    data-kt-drawer-direction='end'
    data-kt-drawer-toggle='#kt_activities_toggle7'
    data-kt-drawer-close='#kt_activities_close7'
  >
    <div className='card shadow-none rounded-0'>
      <div className='card-header' id='kt_activities_header7'>
        <h3 className='card-title fw-bolder text-dark'>Adjunto Janarâ</h3>

        <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-active-light-primary me-n5'
            id='kt_activities_close7'
          >
            <KTIcon iconName='cross' className='fs-1' />
          </button>
        </div>
      </div>
      <div className='card-body position-relative' id='kt_activities_body7'>
        <div
          id='kt_activities_scroll7'
          className='position-relative scroll-y me-n5 pe-5'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-wrappers='#kt_activities_body7'
          data-kt-scroll-dependencies='#kt_activities_header10, #kt_activities_footer7'
          data-kt-scroll-offset='5px'
        >
          <div className='timeline'>
            <Item1 />
            <Item2 />
            <Item3 />
            <Item4 />
            <Item5 />
            <Item6 />
            <Item7 />
            <Item8 />
          </div>
        </div>
      </div>
      <div className='card-footer py-5 text-center' id='kt_activities_footer7'>
        <Link to='#' className='btn btn-bg-body text-primary'>
          Mais sobre o Adjunto Janarã
          <KTIcon iconName='arrow-right' className='fs-3 text-primary' />
        </Link>
      </div>
    </div>
  </div>
)

export {AdjuntoJanara}
